import { isAddressingLocaleKey } from './enum-typeguards';
import { AddressingLocaleKey } from '../generated/types';

export function toAddressingLocaleKey(
    value: string | null | undefined,
    fallback: AddressingLocaleKey = 'en'
): AddressingLocaleKey {
    if (!value) return fallback;
    const candidate = value.toLowerCase().substring(0, 2);
    if (isAddressingLocaleKey(candidate)) {
        return candidate;
    } else {
        return fallback;
    }
}
